import { Directive, Input, ElementRef, OnDestroy, QueryList } from "@angular/core";
import { Select } from "primeng/select";
import { KeyCodes, focusableSelector } from "../../models/key-codes.model";
import { AutoCompleteComponent } from "./auto-complete.component";

@Directive({
  selector: "[formEnhance]",
  standalone: true,
})
export class FormEnhanceDirective implements OnDestroy {
  constructor(private el: ElementRef) { }
  @Input() callback: Function;
  @Input() bindTo;
  @Input() primeNgDropdowns: QueryList<Select>;
  @Input() autoCompleteControls: QueryList<AutoCompleteComponent>;
  keyCodes: KeyCodes = new KeyCodes();
  focusedList: Array<HTMLElement> = [];
  holder: HTMLElement;
  focusableSelectorString: string = focusableSelector;
  focusableEls: NodeList;
  focusableElsLength: number;
  isDirty: boolean;

  ngAfterViewInit() {
    if (!this.callback || !this.bindTo) return;
    this.callback = this.callback.bind(this.bindTo);
    this.holder = this.el.nativeElement;
    this.focusableEls = this.holder.querySelectorAll(
      this.focusableSelectorString
    );
    this.focusableElsLength = this.focusableEls.length;
    if (!this.focusableElsLength) return;
    /*
    [].forEach.call( this.focusableEls, (el: HTMLElement ) => {
      el.addEventListener( 'change' , this.changedChecked.bind( this ) );
    } );
    */

    // setTimeout(() => {
    //   this.primeNgDropdowns &&
    //     this.primeNgDropdowns.changes.subscribe((data: QueryList<Dropdown>) => {
    //       requestAnimationFrame(() => {
    //         this.isDirty = data.map((i) => i.filled).srp_someTrue();
    //       });
    //     });
    // }, 0);

    //setTimeout(() => {
    this.bindTo.hasAutoCompleteControls &&
      this.bindTo.hasAutoCompleteControls.changes.subscribe(
        (data: QueryList<AutoCompleteComponent>) => {
          requestAnimationFrame(() => {
            this.isDirty = true;
          });
        }
      );
    // }, 0);

    this.onDirtyDropdown();
  }

  changedChecked() {
    this.isDirty = true;
  }

  enterKeyupHandler = (event: KeyboardEvent) => {
    if (this.isDirty && event.keyCode === this.keyCodes.enter) {
      if (typeof this.callback === "function") this.callback();
      this.isDirty = false;
    }
  };

  onDirtyDropdown() {
    document.addEventListener("keyup", this.enterKeyupHandler);
  }

  ngOnDestroy() {
    document.removeEventListener("keyup", this.enterKeyupHandler);
  }
}
